export { default } from './components/text.input';
